import React from 'react';

import { WarningOutlined, InfoCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

import './bv-alert.scss';

interface IBVAlert {
    message?: string;
    type: 'error' | 'warning' | 'info';
}

const BVAlert: React.FunctionComponent<IBVAlert> = ({ message, type }) => {
    const _handleAlertByType = () => {
        let alertIcon = <InfoCircleOutlined />;
        let className = '';

        switch (type) {
            case 'error': {
                alertIcon = <CloseCircleOutlined />;
                className = 'bv-alert-error';
                break;
            }
            case 'info': {
                alertIcon = <InfoCircleOutlined />;
                className = 'bv-alert-info';
                break;
            }
            case 'warning': {
                alertIcon = <WarningOutlined />;
                className = 'bv-alert-warning';
                break;
            }
        }

        return (
            <div className={`bv-alert ${className}`} role="alert">
                {alertIcon} {message}
            </div>
        );
    }

    return (
        <React.Fragment>
            {_handleAlertByType()}
        </React.Fragment>
    );
}

export default BVAlert;